import React from 'react';
import classes from './RealGrid.module.scss';

export default function RealGrid({ children }) {
  return <div className={classes.grid}>{children}</div>;
}
